<template>
  <div class="pageContent">
    <img src="../../assets/login.png" alt="Login logo" class="loginLogo" />
    <h2>医院数字影像查询系统</h2>
    <div class="subsetTemplate">
      <van-swipe
        style="height:100%;"
        class="my-swipe"
        indicator-color="white"
        :touchable="false"
        ref="index"
      >
        <van-swipe-item>
          <LoginInput @getsendSms="getsendSms" :checked="checked" />
          <div class="agreement">
            <van-checkbox v-model="checked" shape="square" icon-size="12px" />
            <span style="margin-left:5px">我已同意</span>
            <span style="color:#74b8f5" @click="show = true">《最终用户协议》</span>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <authCode @nextStep="nextStep" @getsendSms="getsendSms" :phone="phone" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- <van-overlay :show="show" @click="show = false">
    <div class="wrapper" @click.stop>-->
    <div id="mask" @click.stop v-show="show"></div>
    <div class="scrollBoxModel" v-show="show">
      <div class="scrollBox">
        <agreement />
        <van-button
          round
          block
          type="info"
          native-type="submit"
          @click.native="onSure"
          style="position:fixed;width:80%;bottom:75px"
        >确定</van-button>
      </div>
    </div>
    <!-- </div>
    </van-overlay>-->
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import Storage from '@/tools/storage'
import LoginInput from '@/components/login/index.vue'
import authCode from '@/components/login/authCode.vue'
import agreement from '@/components/agreement.vue'
import { checkCaptcha, sendSms } from '@/api/login'
export default {
  name: 'login',
  components: { LoginInput, authCode, agreement },
  data() {
    return {
      index: 0,
      phone: '',
      checked: true,
      show: false,
      statusBtn: false
    }
  },
  // watch: {
  //   checked(newName, oldName) {
  //     if (newName) {
  //       this.statusBtn = true

  //     } else {
  //       this.statusBtn = false
  //     }
  //   }
  // },
  methods: {
    onSure() {
      this.show = false
    },
    async getsendSms(params) {
      let data = { phone: params.value1 }
      let res = await sendSms(data)
      if (res) {
        Storage.set('phone', res.phone)
        this.phone = res.phone
        this.$refs.index.swipeTo((this.index = 1))
      }
    },
    async nextStep(params) {
      let key = 'phone'
      let value = this.phone
      params[key] = value
      let res = await checkCaptcha(params)
      if (res) {
        if (Storage.get('remoteUrl') == 1) {
          this.$router.push({ path: '/remoteList' })
        } else {
          if (res === 1) {
            this.$router.push({ path: '/reportList' })
          } else {
            this.$router.push({ path: '/filmQuery' })
          }
        }
      }
    }
  },
  mounted() {}
}
</script>
<style scoped lang="scss">
@import '../../style/login/index.css';
// * {
//   touch-action: none;
// }
.agreement {
  display: flex;
  margin-top: 10px;
  align-items: center;
  justify-content: center;
  padding: 0 5%;
}
.scrollBox {
  width: 80%;
  height: 80%;
  margin: 0 auto;
  padding: 20px;
  background: #ffffff;
}
.blocks::-webkit-scrollbar {
  display: none;
}
.blocks {
  // width: 80%;
  height: 100%;
  border-radius: 10px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.blocks div {
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}
.blocks p {
  text-align: left;
  text-indent: 2em;
}
.blocks .subTitle {
  font-weight: bold;
}

// ceshi
/* 弹窗 */
#mask {
  // display: block;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.scrollBoxModel {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 101;
  display: flex;
  align-items: center;
}
</style>


